import React from "react";

import HeaderMobile from "../Mobile/HeaderMobile";

import Sidebar from "../Desktop/Sidebar";

const Header = props => {
  return (
    <div>
      {props.width <= 1224 ? (
        <HeaderMobile photoURL={props.bloggerData.image} bloggerName={props.bloggerData.name} bloggerData={props.bloggerData} width={props.width} />
      ) : (
        <Sidebar
          photoURL={props.bloggerData.image}
          bloggerName={props.bloggerData.name}
          bloggerData={props.bloggerData}
          setMenuItem={props.setMenuItem}
          menu={props.menu}
        />
      )}
    </div>
  );
};

export default Header;
